import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { setDialogTitle, setMainViewTitle } from '~/redux/slices/location';
import { useAppDispatch } from '~/redux/store/useAppDispatch';
import { isPopupPath } from '~/routes/paths';

/**
 *
 * @param title value of type `string` will set `document.title` to the value of `title`.
 */
export function useDocumentTitle(title: string): void {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();

  const isDialogPath = useRef(isPopupPath(pathname));

  useEffect(() => {
    const isDialog = isDialogPath.current;

    if (title) {
      if (isDialog) {
        dispatch(setDialogTitle(title));
      } else {
        dispatch(setMainViewTitle(title));
      }
    }

    return () => {
      if (isDialog) {
        dispatch(setDialogTitle(''));
      } else {
        dispatch(setMainViewTitle(''));
      }
    };
  }, [title, dispatch]);
}

export function DocumentTitle({ title }: { title: string }): JSX.Element {
  useDocumentTitle(title);
  return <></>;
}
